<template>
  <FormGroup>
    <h5 class="name">หมวดหมู่คอนเทนท์</h5>
     <SelectOptionObject
      :value.sync="scheduleItem.contentCategory"
      :options.sync="contentCategory"
      :multiple="true"
      @onChanged="onSelectedContentCategory" />
  </FormGroup>
</template>

<script>
import _ from 'lodash';
import { loadTaxonomyByKey } from '@/taxonomy/api';
import SelectOptionObject from '@/components/SelectOptionObject.vue';
import FormGroup from '@/components/FormGroup.vue';

export default {
  props: {
    scheduleItem: {
      type: Object,
      default: () => {},
    },
    updateScheduleItemStateError: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FormGroup,
    SelectOptionObject,
  },
  data() {
    return {
      contentCategory: [],
    };
  },
  created() {
    this.loadContentCategories();
  },
  methods: {
    async loadContentCategories() {
      const response = await loadTaxonomyByKey('content-category');
      this.contentCategory = response.data.data;
    },
    onSelectedContentCategory(selectedOption) {
      if (selectedOption) {
        const contentCategory = _.cloneDeep(selectedOption);
        this.$emit('update:scheduleItem', {
          ...this.scheduleItem,
          contentCategory,
          contentCategoryId: contentCategory.id,
        });
      } else {
        this.$emit('update:scheduleItem', {
          ...this.scheduleItem,
          contentCategory: null,
          contentCategoryId: null,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
</style>
